/* eslint-disable no-dupe-keys */
export default {
  top_up: {
    name: '充值',
    // 属性（一般与对象内容匹配）
    prop: {
      created_at: '充值时间',
      prepaid_charge: '预付充电'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      keyword: '关键词',
      trade_number: '交易单号',
      external_trade_number: '第三方交易号',
      user_id: '用户',
      user_tag_id: '用户标签',
      user_first_ev_charging_station: '用户来源站点',
      money_type: '充值类型',
      gateway: '客户端',
      payment_type: '支付方式',
      from_page: '页面来源',
      amount: '充值金额',
      admin_id: '操作员',
      prepaid_charge: '是否预付充电',
      description: '备注',
      created_at: '充值时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    money_types: {
      actual: '基础金额',
      reward: '赠送金额'
    },
    gateways: {
      app: 'App',
      // wechat_web: '公众号',
      wechat_mini: '小程序',
      platform: '平台'
    },
    payment_types: {
      wechat: '微信',
      alipay: '支付宝',
      apple_pay: 'ApplyPay',
      balance_pay: '余额支付',
      union_pay: '银联支付',
      offline_pay: '平台充值',
      ccb_pay: '建行支付'
    },
    from_pages: {
      charge_page: '充电',
      wallet_page: '钱包',
      pay_page: '支付'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '交易单号/备注',
      search_prepaid_charge: '是否预付充电'
    },
    // 详情页标签
    labels: {
      wechat_pay_amount: '微信支付',
      pay_count: '支付次数',
      alipay_amount: '支付宝',
      others_pay_amount: '其他支付',
      total_amount: '总额'
    },
    btn: {
      statistics: '充值统计'
    }
  }
}
